import { Controller } from "@hotwired/stimulus"

// Expand/collapse the add-relationship form; mirrors contact-groups toggleAdd.
export default class extends Controller {
    static targets = ["form", "addBtn"]

    connect() {
        if (this.element.classList.contains("is-expanded") && this.hasAddBtnTarget) {
            this.addBtnTarget.textContent = "Done"
        }
    }

    toggleAdd(event) {
        event.preventDefault()
        if (this.element.classList.contains("is-expanded")) this.collapseAdd()
        else this.expandAdd()
    }

    expandAdd() {
        this.element.classList.add("is-expanded")
        if (this.hasAddBtnTarget) this.addBtnTarget.textContent = "Done"
        let field = this.formTarget.querySelector("input, select")
        if (field) field.focus()
    }

    collapseAdd() {
        this.element.classList.remove("is-expanded")
        if (this.hasAddBtnTarget) this.addBtnTarget.textContent = "+ Add"
    }
}
